module.exports = __webpack_public_path__ + "static/media/2.55bad205.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/swipe/slides/2.png
// module id = 251
// module chunks = 0